import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'
import { Link } from '@olxbr/ds-web'
import Backdrop from '../../atoms/Backdrop'
import Svg from '../../atoms/Svg'

const Content = styled(View)`
  background-color: #fff;
  padding: 32px 24px;
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  border-radius: 10px;
  width: ${({ widthSize }) => (widthSize ? `${widthSize}px` : '400px')};
  @media (max-width: 440px) {
    width: 90%;
  }
`

const TitleBar = styled(View)`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  height: 32px;
`

const LeftArea = styled.button`
  margin-right: auto;
  font-size: 18px;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
`

const RightArea = styled.div`
  margin-left: auto;
`

const Close = styled(Link)``

const internalClose = onClose => event => {
  event.preventDefault()
  onClose()
}

const rootId = 'modalRoot'

const leftArrowSvgPath =
  'M5.81 12.75l4.72 4.72a.75.75 0 0 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 1.06l-4.72 4.72H20a.75.75 0 1 1 0 1.5H5.81z'

const closeSvgPath =
  'M13.06 12l5.47 5.47a.75.75 0 0 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 1.06-1.06L12 10.94l5.47-5.47a.7    5.75 0 0 1 1.06 1.06L13.06 12z'

class Modal extends React.Component {
  componentDidMount() {
    // All access to browser resources must be done in componentDidMount
    this.el = document.createElement('div')
    this.root = document.getElementById(rootId)
    if (!this.root) {
      this.root = document.createElement('div')
      this.root.id = rootId
      document.body.appendChild(this.root)
    }
    this.root.appendChild(this.el)
  }

  componentWillUnmount() {
    this.root.removeChild(this.el)
  }

  render() {
    const { children, onClose, open, onLeftClick, showBackButton, showCloseButton, widthSize } =
      this.props
    return (
      <Backdrop open={open}>
        <Content widthSize={widthSize}>
          <TitleBar>
            {showBackButton && (
              <LeftArea href="#" onClick={onLeftClick}>
                <Svg
                  svgPath={leftArrowSvgPath}
                  height={24}
                  width={24}
                  color="#4A4A4A"
                  viewBox="0 0 24 24"
                />
              </LeftArea>
            )}
            {showCloseButton && (
              <RightArea>
                <Close href="#" onClick={internalClose(onClose)}>
                  <Svg
                    svgPath={closeSvgPath}
                    height={24}
                    width={24}
                    color="#4A4A4A"
                    viewBox="0 0 24 24"
                  />
                </Close>
              </RightArea>
            )}
          </TitleBar>
          {children}
        </Content>
      </Backdrop>
    )
  }
}

Modal.defaultProps = {
  open: true,
  widthSize: null,
  showCloseButton: true,
}

Modal.propTypes = {
  onClose: PropTypes.func,
  onLeftClick: PropTypes.func,
  open: PropTypes.bool,
  showBackButton: PropTypes.bool,
  showCloseButton: PropTypes.bool,
  widthSize: PropTypes.string,
}

export default Modal
